import { createFileRoute } from '@tanstack/react-router';
import { ExploreScreen } from '@/features/explore/ExploreScreen.tsx';

export const Route = createFileRoute('/_app/explore/')({ component: ExploreScreen });
